
import { Component, Vue } from 'vue-property-decorator';
import { FarmStore } from '@/store/modules';
import { Farm } from '@/store/models/farm';
import SvgIcon from '@/components/SvgIcon.vue';
import { QTablePagination } from '@/store/models/meta';

import { colors } from 'quasar';
const { getPaletteColor } = colors;

@Component({
  components: {
    SvgIcon
  }
})
export default class ModelerAlbums extends Vue {
  get farms() {
    return FarmStore.Farms;
  }

  farm: Farm | null = null;

  deleteDialog = false;

  logTab = 'stdout';
  filter = '';

  loading = false;

  tableColumn = [
    {
      name: 'id',
      label: 'Id',
      field: (row: Farm) => row.id,
      sortable: true,
      align: 'left',
      style: 'width: 10px',
      headerStyle: 'width: 10px;'
    },
    {
      name: 'name',
      label: 'Name',
      field: (row: Farm) => row.name,
      sortable: true,
      align: 'left'
    },
    {
      name: 'owner',
      label: 'Owner',
      field: (row: Farm) => row.ownerName,
      sortable: true,
      align: 'left'
    },
    {
      name: 'manager',
      label: 'Manager',
      field: (row: Farm) => {
        return row.farmManager.map(x => x.managerName).join(', ');
      },
      align: 'left'
    },
    {
      name: 'area',
      label: 'Area (ha)',
      field: (row: Farm) => row.area,
      sortable: true,
      align: 'left'
    },
    {
      name: 'actions',
      label: 'Actions',
      align: 'left',
      style: 'width: 260px;'
    }
  ];
  pagination: {
    sortBy: string;
    descending: boolean;
    page: number;
    rowsPerPage: number;
  } = {
    sortBy: 'id',
    descending: true,
    page: 1,
    rowsPerPage: 10
  };

  get farmPagination() {
    return FarmStore.FarmTablePagination;
  }

  set farmPagination(data: QTablePagination) {
    FarmStore.setFarmTablePagination(data);
  }

  getPaletteColor(colorName: string) {
    return getPaletteColor(colorName);
  }

  async onDelete(farmId: number) {
    this.deleteDialog = false;
    if (farmId != 0) {
      FarmStore.deleteFarm(farmId);

      FarmStore.setAddEditFarm({} as Farm);
    }
  }

  deleteFarm(farm: Farm) {
    this.farm = farm;
    this.deleteDialog = true;
  }

  editFarm(farm: Farm) {
    this.farm = farm;
    FarmStore.setAddEditFarm(farm);
  }

  //eslint-disable-next-line
  async onRequest(props: any) {
    const { page, rowsPerPage, sortBy, descending } = props.pagination;
    // const filter = props.filter;
    this.loading = true;

    // const ordering = `${descending ? '-' : ''}${sortBy}`;

    // const queryParams = {
    //   page: page,
    //   search: filter,
    //   ordering: ordering,
    //   pageSize: rowsPerPage
    // };
    // await FarmStore.getAllMyFarms(queryParams);
    this.loading = false;

    this.farmPagination = {
      page: page,
      rowsPerPage: rowsPerPage,
      rowsNumber: this.farms.length,
      sortBy: sortBy,
      descending: descending
    };
  }

  async created() {
    this.loading = true;
    await FarmStore.getAllMyFarms();
    // this.onRequest({
    //   pagination: this.blockPagination,
    //   filter: this.filter
    // });
    this.loading = false;
  }
}
